import { QueryClient } from '@tanstack/react-query';

export const initializeReactQuery = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 10 * 60 * 1000, // 10 minutes
      },
    },
  });

  return { queryClient };
};
